import "./ButtonTelephony.css";
import BotService from "../../../services/BotService";
import { useBotStateContext } from "../../../contexts/BotContext";
import { useEffect, useState } from "react";

function ButtonTelephony() {
    const { botId, code, phone } = useBotStateContext();

    if(!code || !phone) {
        return <></>
    }
    return (
        <div className="button_telephony">
            <div>
                <span>{phone ? phone.match(/.{1,2}/g).join(" ") : ""}</span>
                <span> # {code} </span> 
                {/* add space between # */}
            </div>  
        </div>
    )
}

export default ButtonTelephony;